import { Component, inject } from "@angular/core";
import { AWSLambda } from 'src/app/AWSLambda.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "src/app/services/auth.service";
import { Auth } from "aws-amplify";

@Component({
  selector: "app-promos",
  templateUrl: "./promos.component.html",
})
export class PromosComponent {

  lambda = inject(AWSLambda);
  _snackBar = inject(MatSnackBar);
  authService = inject(AuthService);

  

  promos: any[] = [];     // ← Lista de promociones que llega del API
  loading = true;         // ← Spinner mientras carga
  selectedPromo: any | null = null; // 👉 Promo abierta en el popup

  async ngOnInit() {

    await this.authService.refresh();
    await Auth.currentAuthenticatedUser(); // solo asegura sesión válida
    await this.cargarPromos();

   
  }

  async cargarPromos() {
     try {
      const result: any = await this.lambda.getLambdaFunction(
        'lambda',
        '/user/api',
        {
          queryStringParameters: {
            action: 'get_promos',
          },
        }
      );



      if (result.ok) {
        this.promos = result.promos;
      } else {
        this._snackBar.open("Error cargando promociones", "Cerrar", { duration: 4000 });
      }

    } catch (err) {
      this._snackBar.open("Error llamando al API", "Cerrar", { duration: 4000 });
      console.error(err);
    }

    this.loading = false;

  }



  openPromo(promo: any) {
    this.selectedPromo = promo;
  }

  closePromo() {
    this.selectedPromo = null;
  }

}